import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import {
  GET_SOFT_INFOS_55,
  // BANNER_CONTENT_53,
  BANNER_CONTENT_61,
  RANK_MIX_RANK_53,
  RECOMMEND_CONTENT_53,
  GROUNP_CONTENT_53,
  // GUESS_LIKES_URL,
  GUESS_LIKES_NEW_61,
  RECO_TOP_CONTENTS_66,
  RECO_RECOMMEND_CONTENTS_66,
} from '../config';
import {
  RECOMMEND_BANNER_REQUEST,
  RECOMMEND_BANNER_SUCCESS,
  RECOMMEND_WEEK_HOTS_REQUEST,
  RECOMMEND_WEEK_HOTS_SUCCESS,
  RECOMMEND_RECOMMEND_REQUEST,
  RECOMMEND_RECOMMEND_SUCCESS,
  RECOMMEND_GROUP_REQUEST,
  RECOMMEND_GROUP_SUCCESS,
  GUESS_LIKES_REQUEST,
  GUESS_LIKES_SUCCESS,
  GET_SOFTINFOS_REQUEST,
  GET_SOFTINFOS_SUCCESS,
  RECO_TOP_CONTENTS_REQUEST,
  RECO_TOP_CONTENTS_SUCCESS,
  RECO_RECOMMEND_CONTENTS_REQUEST,
  RECO_RECOMMEND_CONTENTS_SUCCESS,
} from '../constants/recommend';

/**
 * 首页改版后获取banner 2021-1-19 21:43:00
 */
function* fetchRecoBanner(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECO_TOP_CONTENTS_66, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECO_TOP_CONTENTS_SUCCESS,
        payload: {
          ...res.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 首页改版后获取group 2021-1-19 21:43:00
 */
function* fetchRecoRecommend(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECO_RECOMMEND_CONTENTS_66, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECO_RECOMMEND_CONTENTS_SUCCESS,
        payload: {
          ...res.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 频道banners
 */
function* fetchBannerContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(BANNER_CONTENT_61, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_BANNER_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 流行榜
 */
function* fetchWeekHotContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RANK_MIX_RANK_53, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_WEEK_HOTS_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 精品推荐
 */
function* fetchRecommendContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECOMMEND_CONTENT_53, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_RECOMMEND_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 其他推荐group
 */
function* fetchGroupContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GROUNP_CONTENT_53, {
      params: { pageType: param.pageType || 'soft' },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: RECOMMEND_GROUP_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 猜你喜欢
 */
function* fetchGuessLike({ skip = 0, limit = 30 }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GUESS_LIKES_NEW_61, { params: { skip, limit } });
    if (res.data.status === 0) {
      let apps = [];
      if (res.data.data && res.data.data.apps && res.data.data.apps.length > 0) {
        apps = res.data.data.apps;
      }
      yield put({
        type: GUESS_LIKES_SUCCESS,
        payload: { ...res.data.data, apps, skip, limit, loading: false },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 批量获取应用详情
 */
function* fetchSoftInfos({ softIds = [], pns = [], bizInfo = {} }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.post(GET_SOFT_INFOS_55, { softIds, pns, bizInfo });
    if (res.data.status === 0) {
      yield put({
        type: GET_SOFTINFOS_SUCCESS,
        payload: { ...res.data, loading: false, softIds, pns },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchRecoBanner() {
  yield takeLatest(RECO_TOP_CONTENTS_REQUEST, fetchRecoBanner);
}
export function* watchFetchRecoRecommend() {
  yield takeLatest(RECO_RECOMMEND_CONTENTS_REQUEST, fetchRecoRecommend);
}

export function* watchBannerContent() {
  yield takeLatest(RECOMMEND_BANNER_REQUEST, fetchBannerContent);
}
export function* watchWeekHotContent() {
  yield takeLatest(RECOMMEND_WEEK_HOTS_REQUEST, fetchWeekHotContent);
}
export function* watchRecommendContent() {
  yield takeLatest(RECOMMEND_RECOMMEND_REQUEST, fetchRecommendContent);
}
export function* watchGroupContent() {
  yield takeLatest(RECOMMEND_GROUP_REQUEST, fetchGroupContent);
}
export function* watchGuessLike() {
  yield takeLatest(GUESS_LIKES_REQUEST, fetchGuessLike);
}
export function* watchSoftInfos() {
  yield takeLatest(GET_SOFTINFOS_REQUEST, fetchSoftInfos);
}
